<div *ngIf="!showNumeric" class="mx-auto w-full flex group justify-end p-4">
  <a
    *ngIf="currentPage < numberOfPages"
    [routerLink]=""
    [queryParams]="{ page: nextPage }"
    (click)="loadMoreData(currentPage + 1)"
    class="w-full cursor-pointer"
  >
    <span class="cursor-pointer">zobacz wszystkie &rsaquo;</span>
  </a>
</div>

<div class="container mx-auto flex group justify-end p-4"></div>

<div *ngIf="showNumeric && numberOfPages > 1" class="inline-flex flex-row flex-nowrap justify-between items-center">
  <a
    *ngIf="currentPage > 1"
    [routerLink]=""
    [queryParams]="{ page: prevPage }"
    (click)="setCurrentPage(currentPage - 1)"
    class="flex items-center justify-center w-4 h-4 cursor-pointer"
  >
    <
  </a>

  <a
    [routerLink]=""
    [queryParams]="{ page: page == 1 ? undefined : page }"
    *ngFor="let page of pages | slice: startOfSlicePages:endOfSlicePages"
    (click)="setCurrentPage(page)"
    class="flex h-8 font-light"
  >
    <div
      class="
        w-8
        flex
        justify-center
        items-center
        cursor-pointer
        leading-5
        transition
        duration-150
        ease-in-out
        mx-1
        rounded-full
        active:bg-white-100 active:border-2 active:border-blue-25 active:rounded-full active:shadow-xl
      "
      [ngClass]="{ 'bg-white-100 shadow': currentPage == page }"
    >
      {{ page }}
    </div>
  </a>

  <a
    *ngIf="currentPage < numberOfPages"
    [routerLink]=""
    [queryParams]="{ page: nextPage }"
    (click)="setCurrentPage(currentPage + 1)"
    class="flex items-center justify-center w-10 h-4 cursor-pointer"
  >
    >
  </a>
</div>
